import { useEffect, useState, useId } from 'react';
import styles from './style.module.scss';
import { defaultAvatar, CameraIcon } from 'assets';
import { toastMessage } from 'shared/components/toast/Toast';
import { checkFileType } from 'shared/utils/Helper';
import classNames from 'classnames';
import CropThumbnail from 'shared/modal/add_crop_thumbnail/CropThumbnail';

const UploadAvatar = ({ UploadedFile,setArray, setFile, selectedImg, setSelectedImg, defaultAvatarImg, AvatarImgStyle, id }) => {
    const generatedId = useId();
    const inputId = id || generatedId;
    const [profileURL, setProfileURL] = useState(typeof UploadedFile === 'string' ? UploadedFile : '');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [openCrop, setOpenCrop] = useState(false);
    const [backdrop] = useState('static');

    const [isDragging, setIsDragging] = useState(false);

    const MAX_FILE_SIZE_BYTES = 8 * 1024 * 1024; // 8 MB

    const handleImageUpload = (e) => {
        let file = e?.target?.files?.[0];

        if (file) {
            if (!checkFileType(file?.type)) {
                toastMessage('error', 'Only JPG, JPEG, PNG are supported');
                setProfileURL('');
                return;
            }
            if (file.size > MAX_FILE_SIZE_BYTES) {
                toastMessage('error', `Image "${file.name}" exceeds maximum size of 8MB`);
                setProfileURL('');
                return;
            }
            let url = URL.createObjectURL(file);
            setProfileURL(url);
            if (setFile) {
                setFile(file);
                setIsModalOpen(true);
            }
        } else {
            setProfileURL('');
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        let file = e.dataTransfer?.files?.[0];
        if (file) {
            if (!checkFileType(file?.type)) {
                toastMessage('error', 'Only JPG, JPEG, PNG are supported');
                setProfileURL('');
                return;
            }
            if (file.size > MAX_FILE_SIZE_BYTES) {
                toastMessage('error', `Image "${file.name}" exceeds maximum size of 8MB`);
                setProfileURL('');
                return;
            }
            let url = URL.createObjectURL(file);
            setProfileURL(url);
            if (setFile) {
                setFile(file);
                setIsModalOpen(true);
            }
        }
    };

    useEffect(() => {
        setProfileURL(typeof UploadedFile === 'string' ? UploadedFile : profileURL);
    }, [UploadedFile]);

    const removeThumbnailHandler = (e) => {
        e.preventDefault();
        setProfileURL('');
        setSelectedImg('');
        if (setFile) {
            setFile(null);
        }
    };
    return (
        <div className={`p-0  ${styles.Avatar}`} role={'button'}>
            <label
                htmlFor={inputId}
                className={classNames(
                    'position-relative',
                    styles.UploadAvatarContainer,
                    isDragging && styles.DragOverActive
                )}
                role={'button'}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={isDragging ? { border: '2px dashed #3b82f6', transform: 'scale(1.05)', transition: 'all 0.2s ease' } : { transition: 'all 0.2s ease' }}
            >
                {selectedImg && (
                    <div className={styles.RedDot} onClick={removeThumbnailHandler}>
                        x
                    </div>
                )}
                <img
                    src={selectedImg ? selectedImg : defaultAvatarImg ?? defaultAvatar}
                    alt="sign-up-avatar-icon"
                    className={classNames(AvatarImgStyle && AvatarImgStyle, `${styles.signAvatarImgStyle}`)}
                />

                <div className={`${styles.cameraIconStyleContainer}`} role={'button'}>
                    <CameraIcon />
                </div>
            </label>
            <input
                type={'file'}
                name={inputId}
                id={inputId}
                role="button"
                className={`${styles.proilePhotoInput}`}
                onClick={(e) => {
                    e.target.value = null;
                }}
                accept="image/*"
                onChange={(e) => {
                    handleImageUpload(e);
                }}
            />
            {UploadedFile && (
                <CropThumbnail
                    show={isModalOpen}
                    setOpen={setIsModalOpen}
                    UploadedFile={UploadedFile}
                    uploadedPhotoUrl={profileURL}
                    setUploadedPhotoURL={setProfileURL}
                    setOpenCrop={setOpenCrop}
                    cropShape={'rect'}
                    aspect={1}
                    setFile={setFile}
                    handleClose={() => setIsModalOpen(false)}
                    setSelectedImage={setSelectedImg}
                    backdrop={backdrop}
                />
            )}
        </div>
    );
};
export default UploadAvatar;
